import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DefaultCell from "components/CRPComponents/Tables/components/DefaultCell";
import LinkCell from "components/CRPComponents/Tables/components/LinkCell";
import { ListProps } from "./types";
import { GET_ALL_QUERY, GetAllGql } from "./queries/getAll";
import { ApiAuthWithSetData } from "data/ApiAuth";
import ActiveOrInactiveCell from "components/CRPComponents/Tables/components/ActiveOrInactiveCell";
import UserListTable from "components/CRPComponents/Tables/GenericTable copy";
import { MenuItem, TextField } from "@mui/material";
import { useMemo, useState } from "react";

type RoleFilter = "with" | "without" | "all";

const getHasRoleFilter = (roleFilter: RoleFilter) => {
  if (roleFilter === "with") return true;
  if (roleFilter === "without") return false;
  return null;
};

function List(props: ListProps) {
  const [roleFilter, setRoleFilter] = useState<RoleFilter>("with");
  const initialVariables = useMemo(
    () => ({
      search: null,
      hasRole: getHasRoleFilter(roleFilter),
      page: 1,
    }),
    [roleFilter]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <UserListTable<GetAllGql>
        initialVariables={initialVariables}
        path={`/configuracoes/usuarios`}
        query={GET_ALL_QUERY}
        formatRows={(data) => data.Users.items}
        formatPagination={(data) => data.Users.paginationInfo}
        title="NOVO USUÁRIO"
        ApiSetData={ApiAuthWithSetData}
        childrenFilters={
          <TextField
            select
            size="small"
            label="Função"
            value={roleFilter}
            onChange={(event) => setRoleFilter(event.target.value as RoleFilter)}
            sx={{ minWidth: 170 }}
          >
            <MenuItem value="with">Com função</MenuItem>
            <MenuItem value="without">Sem função</MenuItem>
            <MenuItem value="all">Todos</MenuItem>
          </TextField>
        }
        columnsTable={[
          {
            Header: "id",
            accessor: "id",
            Cell: ({ value }: any) => (
              <LinkCell href={`/configuracoes/usuarios/${value}`} value={value} />
            ),
          },
          {
            Header: "Nome",
            accessor: "firstName",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Sobrenome",
            accessor: "lastName",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "UserName",
            accessor: "userName",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Email",
            accessor: "email",
            Cell: ({ value }: any) => <DefaultCell value={value} />,
          },
          {
            Header: "Função",
            accessor: "role",
            Cell: ({ value }: any) => <DefaultCell value={value?.name} />,
          },
          {
            Header: "Ativo?",
            accessor: "active",
            Cell: ({ value }: any) => <ActiveOrInactiveCell value={value === "ACTIVE"} />,
          },
        ]}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default List;
